import { render, staticRenderFns } from "./CommercialJobListDetails.vue?vue&type=template&id=68ba9baf&"
import script from "./CommercialJobListDetails.vue?vue&type=script&lang=js&"
export * from "./CommercialJobListDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports